import { Vue, Component, Ref, Prop } from 'vue-property-decorator'
import AlertBanner from '@/components/common/AlertBanner/alert-banner.vue'

@Component({
    components: {
        AlertBanner
    }
})
export default class BreakdownsModalBasicForm extends Vue {
    @Ref() readonly breakdownsModalBasicForm!: any

    @Prop(String) readonly actionTitle!: string

    show() {
        this.breakdownsModalBasicForm.show()
    }

    hide() {
        this.breakdownsModalBasicForm.hide()
    }
}
